export const recaptcha_error_message_text =
  'Error in fetching token. Please refresh the page.';

export const vehicle_trucks_source = 'trucks_fare_estimate';

export const two_wheeler_source = 'home_2W';
export const trucks_wheeler_source = 'home_Trucks';
export const spot_source = 'spot lead flow';

export const form_submit_ga_event_prefix = 'Get Trip Estimate Click - ';

export const estimate_sub_title =
  'Please fill in the details, so we can provide you with the best of our services';
export const two_wheeler_title_mobile = 'Your Quote is a step away!';

export const pnm_title = 'Packers & Movers';
export const pnm_sub_title = estimate_sub_title;
export const pnm_title_mobile = two_wheeler_title_mobile;
